"use client"
import { ComponentConfig } from "@measured/puck"
import Image from "next/image"
import Link from "next/link"
import { twMerge } from "tailwind-merge"
import { ADMIN_API_CONFIG } from "../../../../../../constants/api-configs"
import { DefaultImage } from "../../../../../../lib/external-components"
import { CommonStylesProps } from "../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../lib/helper"

export interface ImageProps extends CommonStylesProps {
  padding?: string
  border?: string
  heightStyle?: string
  witdhMobile?: string
  widthDesktop?: string
  widthTablet?: string
  heightMobile?: string
  heightTablet?: string
  imageUrl?: string | { url: string; alternativeText?: string; caption?: string }
  borderRadius?: string
  link?: string
  margin?: string
  multiple?: boolean
  showCaption?: boolean
  objectFit?: "cover" | "contain" | "fill" | "none" | "scale-down"
  objectPosition?:
    | "center"
    | "top"
    | "bottom"
    | "left"
    | "right"
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right"
}

export const RenderConfig: ComponentConfig<ImageProps> = {
  // @TODO: missing responsive CSS\

  render: ({
    padding,
    border,
    witdhMobile,
    widthDesktop,
    widthTablet,
    heightStyle,
    heightMobile,
    heightTablet,
    imageUrl,
    borderRadius,
    margin,
    multiple,
    showCaption,
    objectFit,
    objectPosition,
    responsiveType,
    className,
    link,
  }) => {
    const id = `Image-${Math.random().toString(36).substr(2, 9)}`

    // Xử lý imageUrl có thể là string hoặc object
    const imageData =
      typeof imageUrl === "string"
        ? { url: imageUrl, alternativeText: "", caption: "" }
        : imageUrl || { url: "", alternativeText: "", caption: "" }

    const styles = {
      mobile: { height: heightMobile, display: "block", width: witdhMobile },
      tablet: { height: heightTablet, display: "block", width: widthTablet },
      desktop: { height: heightStyle, display: "block", width: widthDesktop },
    }

    return (
      <>
        {generateResponsiveCSS(id, styles || {}, responsiveType)}

        <div className="w-full">
          <Link href={link ?? "#"} className="w-full h-full">
            <Image
              id={id}
              src={imageData.url ? `${ADMIN_API_CONFIG.API_URL}${imageData.url}` : DefaultImage}
              alt={imageData.alternativeText || "placeholder"}
              className={`${id} ${twMerge(className)} ${
                objectFit == "cover"
                  ? "object-cover"
                  : objectFit === "contain"
                  ? "object-contain"
                  : objectFit === "fill"
                  ? "object-fill"
                  : objectFit === "scale-down"
                  ? "object-scale-down"
                  : ""
              } ${
                objectPosition === "top"
                  ? "object-top"
                  : objectPosition === "bottom"
                  ? "object-bottom"
                  : objectPosition === "left"
                  ? "object-left"
                  : objectPosition === "right"
                  ? "object-right"
                  : objectPosition === "top-left"
                  ? "object-left-top"
                  : objectPosition === "top-right"
                  ? "object-right-top"
                  : objectPosition === "bottom-left"
                  ? "object-left-bottom"
                  : objectPosition === "bottom-right"
                  ? "object-right-bottom"
                  : "object-center"
              } ${multiple ? "mix-blend-multiply" : ""}`}
              style={{ padding, borderRadius, margin }}
              width={600}
              height={600}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              // Tối ưu hóa performance
              loading="lazy"
              placeholder="blur"
              blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
            />
          </Link>
          {showCaption && imageData.caption && (
            <p className="text-center text-sm text-gray-600 mt-2 italic">{imageData.caption}</p>
          )}
        </div>
      </>
    )
  },
}
